import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72575ed1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-content" }
const _hoisted_2 = {
  key: 0,
  class: "body"
}
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "px-2" }, "Command Post Acknowledges", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "px-2" }, "Dismiss", -1))

import { computed, ref } from 'vue';
import MarqueeScrollSO from '@/components/system/components/MarqueeScrollSO.vue';
import ButtonComponent from '../../ButtonComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MarqueeCardWidget',
  props: {
    title: null,
    description: null,
    acknowledged: { type: Boolean }
  },
  emits: ["onAcknowledge"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'onAcknowledge'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  title: string;
  description: string;
  acknowledged: boolean;
}




const bodyVisible = ref(!props.acknowledged);

const CLICK_DETAILS = ' - Click for details - ';
const marqueeTitle = computed(() => {
  if (props.title) {
    return props.title + CLICK_DETAILS;
  }
  return CLICK_DETAILS;
});

const toggleVisible = () => {
  bodyVisible.value = !bodyVisible.value;
};

const handleAcknowledged = () => {
  toggleVisible();
  emits('onAcknowledge');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "title",
      onClick: toggleVisible,
      "data-testid": "title-click"
    }, [
      _createVNode(MarqueeScrollSO, {
        title: _unref(marqueeTitle),
        class: "marquee-scroll"
      }, null, 8, ["title"])
    ]),
    (bodyVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(__props.description) + " ", 1),
          _createElementVNode("div", _hoisted_3, [
            (!__props.acknowledged)
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 0,
                  class: "whitespace-nowrap",
                  onClick: handleAcknowledged,
                  "color-type": "tertiary",
                  size: "medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (__props.acknowledged)
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 1,
                  onClick: toggleVisible,
                  "color-type": "tertiary",
                  size: "medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})